import React, { useEffect } from 'react';
import { CATEGORY_PALETTE } from '../achievements';

// A brief, non-blocking toast the instant a milestone is actually crossed —
// previously these only surfaced passively next time Stats was opened.
// Auto-dismisses; the orbs underneath stay tappable throughout.
const AchievementToast = ({ achievement, onDone }) => {
  useEffect(() => {
    if (!achievement) return;
    const id = setTimeout(onDone, 4000);
    return () => clearTimeout(id);
  }, [achievement, onDone]);

  if (!achievement) return null;
  const [from, to] = CATEGORY_PALETTE[achievement.category] || CATEGORY_PALETTE.firstSteps;

  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-toast flex justify-center px-4"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 1rem)' }}
    >
      <div
        role="status"
        className="achievement-toast-in pointer-events-auto flex max-w-[92vw] items-center gap-3 rounded-full border border-white/15 bg-black/70 py-2.5 pl-2.5 pr-4 shadow-2xl backdrop-blur-xl"
      >
        <span
          aria-hidden="true"
          className="h-9 w-9 shrink-0 rounded-full"
          style={{
            background: `radial-gradient(circle at 35% 30%, rgba(255,255,255,.9) 0 3%, ${from} 18%, ${to} 62%, rgba(15,23,42,.9) 100%)`,
            boxShadow: `0 0 16px 2px ${from}55`,
          }}
        />
        <div className="min-w-0">
          <p className="text-[0.5625rem] font-bold uppercase tracking-widest text-indigo-200/70">Milestone reached</p>
          <p className="truncate text-sm font-bold text-white">{achievement.title}</p>
        </div>
      </div>
    </div>
  );
};

export default AchievementToast;
